import type { SVGProps } from "react";
export interface BusIconProps
  extends Omit<SVGProps<SVGSVGElement>, "width" | "height"> {
  className?: string;
  size?: number;
  color?: string;
}
export function BusIcon({
  className = "",
  size = 24,
  color = "currentColor",
  ...props
}: BusIconProps) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      fill="none"
      viewBox="0 0 24 24"
      className={className}
      {...props}
    >
      <path
        fill={color}
        d="M15.5 15.628a.62.62 0 0 0-.125.372l.013.126a.6.6 0 0 0 .111.244zm1 .742a.6.6 0 0 0 .113-.244l.012-.126-.012-.126a.6.6 0 0 0-.113-.246zm-7.888-.496a.6.6 0 0 0-.112-.246v.742a.6.6 0 0 0 .112-.244L8.625 16zM7.5 15.628a.62.62 0 0 0-.125.372l.012.126a.6.6 0 0 0 .113.244zM20 4.375c.62 0 1.125.503 1.125 1.125 0 .355-.168.668-.425.874h.3A1.126 1.126 0 0 1 22.125 7.5V10c0 .622-.504 1.126-1.125 1.126h-.3a1.121 1.121 0 0 1-.585 1.994l-.115.005H4A1.125 1.125 0 0 1 2.875 12c0-.355.168-.668.425-.874H3A1.125 1.125 0 0 1 1.875 10V7.5c0-.622.504-1.126 1.125-1.126h.3a1.12 1.12 0 0 1-.425-.874c0-.622.504-1.125 1.125-1.125zm-6.875 6.5h6.174a1.12 1.12 0 0 1 .576-1.993v-.267a1.118 1.118 0 0 1-.574-1.99h-6.176zm-8.426-4.25a1.118 1.118 0 0 1-.574 1.99v.267a1.12 1.12 0 0 1 .576 1.992h6.174v-4.25H4.699ZM9.625 16a1.625 1.625 0 0 1-3.241.165L6.375 16l.009-.166A1.624 1.624 0 0 1 8 14.375l.166.008c.82.083 1.46.776 1.46 1.617Zm8 0a1.625 1.625 0 0 1-3.242.165L14.375 16l.008-.166A1.625 1.625 0 0 1 16 14.375l.166.008c.82.083 1.459.775 1.459 1.617"
      />
      <path
        fill={color}
        d="M18.875 5.5c0 .01-.005-.125-.156-.36-.144-.222-.41-.516-.882-.814-.949-.599-2.717-1.201-5.838-1.201s-4.887.602-5.835 1.201c-.472.298-.74.592-.884.815-.139.215-.153.347-.155.359V17c0 1.035.84 1.875 1.875 1.875h10c1.036 0 1.875-.84 1.875-1.875zm2.25 11.5c0 1.28-.584 2.425-1.5 3.182V22a1.125 1.125 0 0 1-2.25 0v-.895a5 5 0 0 1-.375.02H7c-.127 0-.251-.01-.375-.02V22a1.125 1.125 0 0 1-2.25 0v-1.818A4.12 4.12 0 0 1 2.875 17V5.5c0-.998.68-2.188 2.087-3.077C6.39 1.523 8.62.875 12 .875s5.613.648 7.04 1.548c1.406.889 2.086 2.079 2.086 3.077z"
      />
    </svg>
  );
}
